import React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Media} from 'reactstrap';
import { Translate } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faIdCard, faDownload} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";


export default class NavbarMobile extends React.Component {
    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    render() {
        return (

            <div>
                <Navbar className="navbar-mobile navbar-landing" color="faded" dark>
                    <NavbarBrand href="/" className="mr-auto">
                        <Media src={require('../../img/logo-gs-a.png')} alt="Company logo"
                               className="logo-mob"/>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2 navbar-button" />
                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Nav navbar>
                            <NavItem>
                                <NavLink to="/" className="navbar-button">
                                    <FontAwesomeIcon icon={faHome} />{' '}
                                    <Translate id="navbar-landing.home" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/login" className="navbar-button">
                                    <FontAwesomeIcon icon={faUser} />{' '}
                                    <Translate id="navbar-landing.my-account" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/register" className="navbar-button">
                                    <FontAwesomeIcon icon={faIdCard} />{' '}
                                    <Translate id="navbar-landing.subscribe" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/download" className="navbar-button">
                                    <FontAwesomeIcon icon={faDownload} />{' '}
                                    <Translate id="navbar-landing.download" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/navbar/navbar-landing.js